import { Component, computed, inject, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Industry } from '@app/shared/types/models/industry/industry.model';
import {
  ProffeoUiTableAction,
  ProffeoUiTableActionEvent,
  ProffeoUiTableColumn,
  UiTableComponent
} from '@app/shared/ui';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-industries-list',
  imports: [MatIconModule, TranslatePipe, MatMenuModule, UiTableComponent],
  templateUrl: './industries-list.component.html'
})
export class IndustriesListComponent {
  private readonly translateService = inject(TranslateService);

  protected readonly columns = computed((): ProffeoUiTableColumn<Industry>[] => [
    {
      columnId: 'name',
      columnName: this.translateService.instant('company-industries.table-headers.name'),
      dataType: 'string',
      accessor: industry => industry.name,
      sortable: false,
      hideable: false,
      widthPx: 480,
      minWidthPx: 180
    }
  ]);
  protected readonly rowActions = computed((): ProffeoUiTableAction<Industry>[] => [
    {
      id: 'edit',
      label: this.translateService.instant('company-industries.list-actions.edit'),
      icon: 'edit'
    },
    {
      id: 'delete',
      label: this.translateService.instant('company-industries.list-actions.delete'),
      icon: 'delete'
    }
  ]);

  public readonly industries = input.required<Industry[]>();
  public readonly editIndustry = output<Industry>();
  public readonly deleteIndustry = output<Industry>();

  protected resolveRowId(industry: Industry): string {
    return industry.id;
  }

  protected onTableAction(event: ProffeoUiTableActionEvent<Industry>): void {
    if (event.actionId === 'edit') {
      this.onEditIndustry(event.row);
    } else if (event.actionId === 'delete') {
      this.onDeleteIndustry(event.row);
    }
  }

  protected onEditIndustry(industry: Industry): void {
    this.editIndustry.emit(industry);
  }

  protected onDeleteIndustry(industry: Industry): void {
    this.deleteIndustry.emit(industry);
  }
}
